<template>
    <b-modal
        id="tagless-students-modal"
        v-model="loaded"
        ref="tagless-students-modal"
        size="lg"
        :title="$t('internship.delete_these_students')"
        modal-class="apprentice-default-modal create-internship-tag"
        :ok-title="$t('common.confirm')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @show="load($event)"
        @ok="save()">
        <b-form-group
            v-slot="{ ariaDescribedby }"
            :lable="$t('internship.these_students_will_be_stuck_with_the_internship_without_a_core_group')">
            <b-form-checkbox-group
                id="lostStudentTable"
                v-model="selectedStudents"
                :aria-describedby="ariaDescribedby"
                name="lost-student-table">
                <design-2021-apprentice-data-table
                    :items="tableData"
                    :fields="studentFields">
                    <template v-slot:cell(action)="data">
                        <b-form-checkbox :value="data.item.id" />
                    </template>

                    <template v-slot:cell(accepted)="data">
                        <div class="status">
                            <i
                                class="fas fa-fw icon"
                                :class="data.item.accepted ? 'fa-check color-success' : 'fa-times color-danger'"></i>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
            </b-form-checkbox-group>
        </b-form-group>
    </b-modal>
</template>

<script>
// import {ords} from "../../../app";
// import moment from "moment";

export default {
    name: 'design-2021-internship-edit-details-tab-lost-students-modal-component',
    props: ['internshipIn', 'studentIdArrayIn'],
    data() {
        return {
            loaded: false,
            students: [],
            selectedStudents: [],
            studentFields: [
                {
                    key: 'action',
                    label: this.$t('common.delete'),
                },
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'accepted',
                    label: this.$t('internship.accepted'),
                },
            ],
        };
    },
    methods: {
        load(data) {
            if (!this.loaded) {
                this.students = data;
                this.loaded = true;
            }
        },
        save(event) {
            this.$emit('save', this.selectedStudents);
        },
    },
    computed: {
        tableData() {
            if (this.loaded === false) {
                return [];
            } else {
                return this.students.map((student) => {
                    return {
                        id: student.id,
                        name: student.full_name,
                        email: student.email,
                        accepted: student.pivot.accepted,
                    };
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.icon {
    font-size: $base-font-size;
}
</style>
